import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import _ from "lodash";
import { Page } from "@packages/ui";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { Button, TextField } from "@packages/ui";
import getServiceFromUrl from "../../utils/getServiceFromUrl";
import getCountryFromURL from "src/utils/getCountryFromUrl";
import { REGIONS, COUNTRY } from "../../utils/constants";
import { Box, Container, makeStyles, InputAdornment } from "@material-ui/core";
import Divider from "@material-ui/core/Divider";
import SnackBar from "../../layouts/SnackBar";
import { apiURI } from "../../env";
import * as checkinActions from "src/actions/checkinActions";




const useStyles = makeStyles((theme) => ({
  // root: {
  //   backgroundColor: theme.palette.background.dark,
  // },
  tile: {
    width: "100%",
    color: "white"
  },
  container: {
    paddingTop: 35,
    paddingBottom: 20,
    borderRadius: 5,
    [theme.breakpoints.up("xs")]: { border: "none", borderRadius: 0 },
    [theme.breakpoints.up("sm")]: {
      border: "solid 1px lightgrey",
      borderBottom: `solid 5px ${theme.palette.primary.main}`,
      borderRadius: 5,
    },
  },
  box: {
    [theme.breakpoints.up("xs")]: {
      marginTop: -30,
    },
    [theme.breakpoints.up("md")]: {
      marginTop: -80,
    },
    [theme.breakpoints.up("lg")]: {
      marginTop: -110,
    },
    [theme.breakpoints.up("xl")]: {
      marginTop: -150,
    },
  },
  textField: {
    background: "white",
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {

      border: "2px solid grey !important"
    },
    // "& .MuiOutlinedInput-notchedOutline": {
    //   backgroundColor: "white"
    // }
  }
}));

const GenericCheckInView = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const checkin = useSelector((state) => state.checkin);
  const urlParams = new URLSearchParams(window.location.search);
  const url = window.location.href;

  // const resNo = urlParams.get("b") ? urlParams.get("b") : "";
  const [resNo, setResNo] = useState(urlParams.get("b"));
  const [values, setValues] = useState(getCountryFromURL() == "AU" ? COUNTRY[0] : COUNTRY[1]);


  const isAdditionalDriver = window.location.pathname.includes("additional") || checkin.isAdditionalDriver;

  const randomNumber = Math.random();

  const isLocal = url.includes('dev.io');
  const isStaging = url.includes('staging');

  const brand = checkin.brand;
  const country = getCountryFromURL().toLowerCase();

  const domainBrand = brand == 'Dollar' ? 'dollarcarrental' : brand;
  const getBase = () => {
      let base;
      if (isLocal) {
          base = 'dev.io';
      } else if (isStaging) {
          base = `portal.staging.hertz.asiapac.io`;
      } else {
          const topDomain = country == 'au' ? 'com.au' : 'co.nz'
          base = `myjourney.${domainBrand}.${topDomain}`;
      }
      return base;
  }

  const redirectBaseUrl = getBase();



  useEffect(() => {
    if (checkin.auth.token != "" && checkin.auth.success && _.isEmpty(checkin.resNo)) {
      dispatch(checkinActions.checkinGeneric({ token: checkin.auth.token }));
    }
  }, [checkin.auth.token]);

  useEffect(() => {
    if (
      checkin.auth.token != "" &&
      checkin.auth.success &&
      checkin.brand &&
      _.isEmpty(checkin.reservation)
    ) {
      // console.log(redirectBaseUrl);
      // console.log(`http://${redirectBaseUrl}/checkin/login?b=${resNo}&genericCheckin=${true}&brand=${brand}`)
      location = `http://${redirectBaseUrl}/checkin/login?b=${resNo}&genericCheckin=${true}&brand=${brand.toLowerCase()}`;
    }
  }, [checkin.brand]);


  const validationSchema = Yup.object().shape({
    bookingNumber: Yup.string()
      .required("Required")
      .test("bookingNumber", "Booking Number is invalid", function (bkNumber) {
        const bookingLength = bkNumber.trim().length;
        const islength =
          bookingLength == 6
            ? true
            : bookingLength == 10
              ? true
              : bookingLength == 11
                ? true
                : false;
        return islength;
      })
  })


  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: {
      bookingNumber: "",
      travelCountry: values,
    },
  });

  const onSubmit = (data) => {
    const bookingNumber = data.bookingNumber.trim().toUpperCase();
    const country = data.travelCountry.value;
    setResNo(bookingNumber)
    dispatch(checkinActions.checkinAuth({ bookingNumber, isGenericCheckin: true, country }));
  };

  return (
    <Page
      className={classes.root}
      title="Login - Generic Check-in"
      style={{ textAlign: "center" }}
    >
      <SnackBar />

      {(resNo != null && (!_.get(checkin, 'auth.success', false))) && <img
        src={`${apiURI}/pixel/${window.location.pathname.replace(/\//g, '_')}.png?b=${resNo}&a=${"click"}&country=${getCountryFromURL()}&c=${randomNumber}&brand=${brand}&t=${isAdditionalDriver ? "additional_driver" : "primary_driver"}`}
        style={{ display: 'none' }}
      />
      }

      <Box display="flex" flexDirection="row" justifyContent="center" marginTop="20vh !important" >
        <Container maxWidth="sm">
          <h1 style={{ color: "white" }} >Welcome to Online Checkin</h1>
          <br />
          <h3 style={{ color: "white" }}>To Continue, Start with your Booking Number</h3>
          <Divider style={{ marginTop: 20, marginBottom: 10 }} />

          <form onSubmit={handleSubmit(onSubmit)}>
            <div>
              <Controller
                control={control}
                name="bookingNumber"
                render={({ field: { onChange, value, name, ref } }) => (
                  <TextField
                    fullWidth
                    id="generic-checkin-bookingNumber"
                    value={value.toUpperCase()}
                    onChange={onChange}

                    InputProps={{
                      startAdornment: <InputAdornment position="start">Booking NO:</InputAdornment>,
                    }} error={errors.bookingNumber ? true : false}
                    className={classes.textField}
                    helperText={errors.bookingNumber ? errors.bookingNumber.message : null}
                  />
                )}
              />
            </div>
            <Box style={{ marginTop: 15, backgroundColor: "white" }}>
              <Button fullWidth loading={checkin.loading} style={{ backgroundColor: "#D3D3D3" }} type="submit" title={"Continue"} />
            </Box>

          </form>
        </Container>
      </Box>
      <div style={{ height: 50 }}></div>
    </Page>
  );
};

export default GenericCheckInView;
